import api, { CreateServiceUrl, Response, ResponsibleFuction } from './api'

const u = CreateServiceUrl('restaurant')

const getRestaurantBySlug: ResponsibleFuction = (slug: string) => {
  const url = `get/getrestaurantbyslug/${slug}/`
  return api.get(u`${url}`)
}

const createOrderPayment: ResponsibleFuction = (orderId: number, data: any) => {
  const url = `${orderId}/order/payment`
  return api.post(u`${url}`, data)
}

const createOrder: ResponsibleFuction = (orderId: number, data: any) => {
  const url = `${orderId}/order/create`
  return api.post(u`${url}`, data)
}

const ordersPerTimeInterval: ResponsibleFuction<any[]> = (data: FormData) => {
  return api.post(
    u`orderspertimeinterval/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getAskServiceGuy: ResponsibleFuction = (restaurantId: string, tableId: string) => {
  const url = `sendFcm/AskserviceGuy/${restaurantId}/table/${tableId}`
  return api.get(
    u`${url}`,
  )
}

const getBill: ResponsibleFuction = (restaurantId: string, tableId: string) => {
  const url = `sendFcm/AskfOrBill/${restaurantId}/table/${tableId}`
  return api.get(
    u`${url}`,
  )
}
const getRestaurantVacationDays = (id: string) => {
  const url = `${id}/vacationdays`
  return api.get(u`${url}`)
}


export {
  getRestaurantBySlug, createOrderPayment, createOrder,
  ordersPerTimeInterval, getAskServiceGuy, getBill, getRestaurantVacationDays,
}
